import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Links } from "components/common";
import { HEADER_LINKS } from "../config";
import { Container, NavItem } from "./styles";
import Actions from "../../Header/RightPanel/Actions";
import { useDispatch } from "react-redux";
import * as userActions from "redux/actions/userActions";

const NavLinks = (props) => {
  const { pathname: currentUrl } = useLocation();

  const { selectedClient } = props;
  const dispatch = useDispatch();

  const headerWithActive = HEADER_LINKS.map((link) => ({
    ...link,
    isActive: currentUrl.split("/")[1] === link.url.split("/")[1],
  }));


  const handleNavClick = (label, url, event) => {
    dispatch(userActions.resetSelectedNotificationComment());
  };

  const activeHeaders = headerWithActive;

  return (
    <Container>
      {selectedClient &&
        activeHeaders.map(({ label, url, isActive }, index) => (
          <NavItem key={index}>
            {label !== "Insights" && (
              <Links
                to={url}
                isActive={isActive}
                onClick={(event) => handleNavClick(label, url, event)}
              >
                {label}
              </Links>
            )}
            {label === "Insights" && <Actions />}
          </NavItem>
        ))}
    </Container>
  );
};

export default NavLinks;
